
<div class="infinite-scroll" v-if="hasMoreData">
  <spinner />
</div>
